/**
 * 新增调拨单
 */
import {useEffect, useMemo, useState} from "react";
import useUpLoadGetProductList from "../../@hooks/useUpLoadGetProductList";
import service from "../../@services";
import useGetProductTransfersAmountText from "./hooks/useGetProductTransfersAmountText";
import useFullListGetPageData from "../../@hooks/useFullListGetPageData";
import {Button, Card, Form, Input, message, Modal, Space, Tooltip} from "antd";
import {CloseOutlined, DownloadOutlined, ExclamationCircleOutlined, PlusOutlined} from "@ant-design/icons";
import ProductTransfersList from "./components/ProductTransfersList";
import ProductSearchModal from "../Product/components/ProductSearchModal";
import StoreSelectBase from "../../components/BaseInfoSelects/StoreSelectBase";
import StoreSelectAll from "../../components/BaseInfoSelects/StoreSelectAll";
import * as Utils from "../../@utils";
const importProductUrl = 'inventory/allocation/import/product'
const rowKey = 'barcode'
const maxCount = 999999
const { confirm } = Modal;
const useUploadFileGetProductInfos = ({ storeCode }) => {
  const [finalList, setList] = useState([])
  const { list, uploadBtn } = useUpLoadGetProductList({
    actionUrl: importProductUrl,
    requestData: { storeCode }
  })
  const handleSave = row => {
    const newData = [...finalList]
    const index = newData.findIndex(item => row[rowKey] === item[rowKey])
    newData.splice(index, 1, row)
    setList(newData)
  }
  useEffect(() => {
    setList(list)
    return () => {}
  }, [list])
  return {
    setList,
    list: finalList,
    handleSave,
    uploadBtn
  }
}
export default function AddProductTransfers(props){
  const no = props.location.query?.checkNo
  const sourceStoreCode = props.location.query?.sourceStoreCode
  const type = props.location.query?.type
  const [loading, setLoading] = useState(false)
  const [cofimLoading, setCofimLoading] = useState(false)
  const { list, setList, uploadBtn, handleSave } = useUploadFileGetProductInfos(
    {
      storeCode: sourceStoreCode,
      recordUpdate: record => {
        return {
          ...record,
        }
      }
    }
  )
  const [showAddProductList, setShowAddProductList] = useState(false)
  const displayData = useGetDisplayDataByList(list)
  const { amountInfoText } = useGetProductTransfersAmountText(displayData)
  const [page, setPage] = useState({
    pageIndex: 1,
    pageSize: 10
  })
  const { pageData } = useFullListGetPageData({ list, page })
  const [form] = Form.useForm()
  form.setFieldsValue({
    sourceStoreCode: sourceStoreCode,
    status: 'NOT_START',
    no: no
  })
  const tableColumns = [
    {
      title: '当前剩余库存',
      dataIndex: 'stock'
    },
    {
      title: '调出数量',
      dataIndex: 'quantity',
      formatter: (val, record) => {
        val = val && Math.abs(parseInt(val))
        if (val) {
          if(val > record.stock){
            message.info(`调出数量大于当前剩余库存:${record.stock}`);
            return ''
          }
          return val > maxCount ? maxCount : val
        }
      }
    },
    {
      title:  () => (
        <Tooltip title='调出金额=成本价*调出数量'>
          <div>
            <span style={{ marginRight: '6px' }}>调出金额</span>
            <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
          </div>
        </Tooltip>
      ),
      dataIndex: 'quantityTakeCostPrice',
      render:(text, record)=> (record.quantity *record.costPrice).toFixed(2)
    },
  ]
  const operateColumns = [
    {
      title: '操作',
      dataIndex: 'id',
      render: (text, record, index) => (
        <Button
          size='small'
          onClick={() =>
            setList(list.filter(item => item.barcode != record.barcode))
          }>
          删除
        </Button>
      )
    }
  ]
  const getDraftBill = async () => {
    setLoading(true)
    try {
      const res = await service.inventory.allocationDetail(no)
      if (res) {
        form.setFieldsValue({
          destStoreCode: res.destStoreCode,
          sourceStoreCode: res.sourceStoreCode,
          status: res.status,
          note: res.note
        })
        setList(res.products)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  // 取消
  const onCancel = ()=>{
    props.history.go(-1)
  }
  // 提交保存
  const saveBillAsDraft = async () => {
    setLoading(true)
    try {
      await form.validateFields()
      const flist = list.filter((item)=> item.quantity == 0 || item.quantity == null || item.quantity == '')
      if (flist.length>0){
        message.error('请输入大于0的数量')
        setLoading(false)
        return
      }
      const tList = list.map((item)=>({quantity: item.quantity, skuId: item.skuId}))
      await service.inventory.allocationCreate({
        ...form.getFieldsValue(),
        products: tList,
        no: no,
      })
      setLoading(false)
      message.success('操作成功');
      onCancel()
    } catch (error) {
      setLoading(false)
    }
  }
  // 确认并出库
  const completeBill = async () => {
    await form.validateFields()
    const flist = list.filter((item)=> item.quantity == 0 || item.quantity == null || item.quantity == '')
    if (flist.length>0){
      message.error('请输入大于0的数量')
      return
    }
    const tList = list.map((item)=>({quantity: item.quantity, skuId: item.skuId}))
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确认是否生成调拨单，调拨单生成后库存将发生变动',
      okText: '确认',
      cancelText: '取消',
      onOk: async ()=>{
        setCofimLoading(true)
        try {
          await service.inventory.allocationCreateSubmit({
            ...form.getFieldsValue(),
            products: tList,
            no: no,
          })
          message.success('操作成功');
          debugger;
          onCancel()
          setCofimLoading(false)
        }catch (error){
          setCofimLoading(false)
        }
      }
    })
  }
  const confirmProductList = async _list => {
    let tList = []
    _list.forEach(item=> {
      const index = list.findIndex(tItem=> tItem.barcode == item.barcode)
      if(index == -1){
        item.quantity = item.quantity ?? 0
        item.costPrice = item.costPrice ?? 0
        tList.push(item)
      }
    })
    setList([...tList, ...list])
    setShowAddProductList(false)
  }
  const footer = (
    <Space style={{ textAlign: 'right' }}>
      <Button type='primary' onClick={saveBillAsDraft} loading={loading} disabled={cofimLoading}>
        提交保存
      </Button>
      <Button type='primary' onClick={completeBill} loading={cofimLoading} disabled={loading}>
        确认并出库
      </Button>
      <Button onClick={onCancel}>取消</Button>
    </Space>
  )
  const downloadTemplate = () => {
    service.common.getFileTemplate({
      fileType: 'allocationProductTemplate'
    }).then((res)=>{
      Utils.download(res, '导入商品模版.xlsx')
    })
  }
  useEffect(() => {
    if (no && type === 'edit') {
      getDraftBill()
    }
    return () => {}
  }, [no])
  return(
    <Card
      title='新增商品调拨单'
      className='customer-card'
      actions={[footer]}
      extra={<CloseOutlined onClick={onCancel} />}>
      <Form form={form} layout='inline' initialValues={{ no }}>
        <Form.Item name='no' label='单据编号'>
          <Input disabled placeholder='请输入' />
        </Form.Item>
        <Form.Item name='sourceStoreCode' label='调出门店'  required rules={[{ required: true, message: '请选择调出门店' }]}>
          <StoreSelectBase
            disabled={true}
            style={{ width: '160px' }}
          />
        </Form.Item>
        <Form.Item name='destStoreCode' label='调入门店' required rules={[{ required: true, message: '请选择调入门店' }]}>
          <StoreSelectAll style={{ width: '160px' }} />
        </Form.Item>
        <Form.Item
          name='handlerName'
          rules={[{ required: true, message: '请输入经手人' }]}
          label='经手人'>
          <Input placeholder='请输入' />
        </Form.Item>
      </Form>
      <div style={{ textAlign: 'left', margin: '20px 0' }}>
        <Space>
          <Button
            type='primary'
            icon={<PlusOutlined />}
            onClick={() => setShowAddProductList(true)}>
            选择商品
          </Button>
          {uploadBtn}
          <Button type="primary" icon={<DownloadOutlined />} onClick={downloadTemplate}>下载模版</Button>
        </Space>
      </div>
      <ProductTransfersList
        page
        edit
        editDataIndex='quantity'
        handleSave={handleSave}
        getList={setPage}
        tableColums={tableColumns}
        operateColums={operateColumns}
        unit='packageUnitName'
        pageData={pageData}
      />
      <ProductSearchModal
        storeCode={sourceStoreCode}
        visible={showAddProductList}
        close={() => setShowAddProductList(false)}
        confirmListHaveInfo={confirmProductList}
      />
      {amountInfoText}
      <Form form={form}>
        <Form.Item
          name='note'
          label='备注'
          rules={[
            { max: 50, message: '备注不超过50个字符', type: 'string' }
          ]}>
          <Input.TextArea placeholder='请输入备注' />
        </Form.Item>
      </Form>
    </Card>
  )
}
const useGetDisplayDataByList = (list = []) => {
  const { checkProductTypeNum, totalQuantity, totalCostPrice } =
    useMemo(() => {
      let totalQuantity = 0,
          totalCostPrice = 0
      if (list.length > 0) {
        list.map(item => {
          totalQuantity += (item.quantity || 0) - 0
          totalCostPrice += item.quantity && item.costPrice ? item.quantity *item.costPrice : 0
        })
      }
      return {
        checkProductTypeNum: list.length,
        totalQuantity: totalQuantity,
        totalCostPrice: totalCostPrice.toFixed(2)
      }
    }, [list])
  return {
    checkProductTypeNum,
    totalQuantity,
    totalCostPrice
  }
}
